import { c as _c } from "react/compiler-runtime";
import useProductBasicDetails from 'data-hooks/useProductBasicDetails';
import useIsLoggedInCallback from 'data-hooks/useUserData/useIsLoggedInCallback';
const usePDPGetBasicDetails = (t0, t1) => {
  const $ = _c(13);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug
  } = t2;
  let t3;
  if ($[2] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    skip: t4
  } = t3;
  const skip = t4 === undefined ? false : t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {};
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== skip) {
    t6 = {
      skip
    };
    $[5] = skip;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    data,
    error,
    rawLoading: loading,
    rawData,
    refetch
  } = useProductBasicDetails(null, slug, t5, t6);
  useIsLoggedInCallback(refetch);
  const t7 = loading && !rawData;
  const t8 = rawData && !data;
  let t9;
  if ($[7] !== data || $[8] !== error || $[9] !== refetch || $[10] !== t7 || $[11] !== t8) {
    t9 = {
      data,
      error,
      loading: t7,
      isProductNotFound: t8,
      refetch
    };
    $[7] = data;
    $[8] = error;
    $[9] = refetch;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default usePDPGetBasicDetails;